<template>
  <b-container class="pt-3">
    <b-row>
      <b-col
        sm="auto"
        lg="5">
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-model="filter"
              placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn
                :disabled="!filter"
                variant="search"
                @click="filter = ''">
                Clear
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :items="approvals"
          :fields="fields" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { Approval } from '@/services/api'

export default {
  name: "Approvals",
  data() {
    return {
      loading: false,
      approvals: [],
      sortBy: 'club',
      sortDesc: false,
      filter: null,
      fields: [
        { key: 'major.version', sortable: true },
        { key: 'minor.version', sortable: true },
        { key: 'file.name', sortable: true },
        { key: 'status', sortable: true },
        { key: 'createdBy', sortable: true },
        { key: 'createTime', sortable: true },
      ],
    }
  },
  async created() {
    this.approvals = await Approval.list()
  },
  methods: {
  },
}
</script>

<style scoped>

</style>
